
import Container = createjs.Container;
import Rectangle = createjs.Rectangle;

export class ItemHelper {
    public static scaleItem(itemMC: Container, baseWidth: number = 70): number {
        var bounds: Rectangle = itemMC.getBounds(null);
        var scaleFactor: number = baseWidth / bounds.width;
        if (bounds.height * scaleFactor > baseWidth) {
            scaleFactor = baseWidth / bounds.height;
        }
        if(scaleFactor > 1.5) {
            scaleFactor = 1.5;
        }
        itemMC.scaleX = itemMC.scaleY = scaleFactor;
        itemMC.x = - ((bounds.width * scaleFactor) / 2 + (bounds.left * scaleFactor));
        itemMC.y = - ((bounds.height * scaleFactor) / 2 + (bounds.top * scaleFactor));
        return scaleFactor;
    }
}
